import React from 'react';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';
import SkeletonImg from 'Components/Skeleton/SkeletonImg';

// Matches the hero in BlogPostView
const COVER_SIZES = '(min-width: 1520px) 872px, (min-width: 1200px) 740px, (min-width: 992px) 621px, (min-width: 768px) 704px, (min-width: 576px) 492px, 95vw';

// Prismic serves each cover size at its own URL, which can't be derived from the original's, so the slot's value is
// the whole srcset, built like BlogPostView's
const coverSources = srcSet => ({ srcSet, src: '' });

/**
 * Blog post while it loads: BlogPostView's hero, title and the start of the article, with the sidebar on desktop.
 * Slots: `cover-srcset` (srcset of the cover image), `title` (text).
 */
export default function BlogPostPageSkeleton() {
  return (
    <div className="BlogPostPageSkeleton">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-8">
            <div className="responsive-image responsive-image--16by9 BlogPostPageSkeleton__hero">
              <SkeletonImg slot="cover-srcset" sizes={COVER_SIZES} sources={coverSources} className="img-force-full" />
            </div>

            <div className="BlogPostPageSkeleton__article">
              <div className="row mb-4">
                <div className="col-12 col-md-10">
                  <SkeletonBlock text tag="h1" slot="title" className="BlogPostPageSkeleton__title" />
                  <SkeletonBlock className="BlogPostPageSkeleton__line" />
                </div>
                <div className="col-md-2 d-none d-md-block">
                  <SkeletonBlock className="BlogPostPageSkeleton__date" />
                </div>
              </div>
              <SkeletonBlock className="BlogPostPageSkeleton__intro mb-4" />
              <SkeletonBlock className="BlogPostPageSkeleton__line" />
              <SkeletonBlock className="BlogPostPageSkeleton__line" />
              <SkeletonBlock className="BlogPostPageSkeleton__line" />
            </div>
          </div>

          <div className="col-lg-4 d-none d-lg-block">
            <SkeletonBlock className="BlogPostPageSkeleton__aside" />
          </div>
        </div>
      </div>
    </div>
  );
}
